import React, { Suspense } from "react";
import { Flex, Text } from "@chakra-ui/react";
import useGetOrderSheetSetInquiries from "@/features/my-order/features/order-history/hooks/useGetOrderSheetSetInquiries";

interface Props {
  orderSheetSetId: number | null;
}

function InquiryUnreadBadgeInner({ orderSheetSetId }: Props) {
  const { data } = useGetOrderSheetSetInquiries(orderSheetSetId);
  const unreadCount = data?.unread_count ?? 0;
  if (unreadCount <= 0) return null;
  return (
    <Flex
      display={"inline-flex"}
      verticalAlign={"middle"}
      marginLeft={"3px"}
      flexShrink={0}
      minWidth={"18px"}
      height={"18px"}
      paddingX={"5px"}
      borderRadius={"full"}
      background={"#FF6B35"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Text
        fontSize={"11px"}
        fontWeight={"700"}
        lineHeight={1}
        color={"#FFFFFF"}
        // 글꼴의 위·아래 여백(ascent/descent)이 달라 숫자가 원 안에서 위아래로 치우친다 —
        // 글자 상자를 대문자 높이~기준선으로 잘라 숫자 자체가 가운데 오게 한다
        sx={{ textBox: "trim-both cap alphabetic" }}
      >
        {unreadCount > 99 ? "99+" : unreadCount}
      </Text>
    </Flex>
  );
}

// 안 읽은 문의 개수 배지. 데이터 로딩은 Suspense로 격리해 부모를 막지 않는다.
export default function InquiryUnreadBadge({ orderSheetSetId }: Props) {
  return (
    <Suspense fallback={null}>
      <InquiryUnreadBadgeInner orderSheetSetId={orderSheetSetId} />
    </Suspense>
  );
}
